import {
  TEntityResponse,
  TEntityListResponse,
  TStateTypeResBody,
  TStateTypeSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TStatesClient = {
  get(id: string): Promise<TEntityResponse<'state-type', TStateTypeResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'state-type', TStateTypeSummaryResBody> | undefined>;
};

function StatesClient(apiClient: TAPIClient): TStatesClient {
  return {
    async get(id: string): Promise<TEntityResponse<'state-type', TStateTypeResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'state-type', TStateTypeResBody>>(`/state-types/${id}`);

      if (data && data.type !== 'state-type') {
        throw new Error('Invalid entity type received, expected: state-type, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'state-type', TStateTypeSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'state-type', TStateTypeSummaryResBody>>(
        `/state-types?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'state-type') {
        throw new Error('Invalid entity type received, expected: state-type, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TStatesClient, StatesClient };
